import type { RoundSnapshot } from '@urbanrats/contracts';
import type { GameInfo } from '../gateway/index.ts';
import { useI18n, type MessageKey } from '../i18n/index.ts';
import { fmtOdds } from '../lib/format.ts';
import { conditionText, gameBlurbKey, selectionLabel } from '../lib/gameText.ts';

export function RulesPanel({ round, game, realMoney = false }: { round: RoundSnapshot | null; game: GameInfo; realMoney?: boolean }) {
  const { t, intl } = useI18n();
  const mode = round?.manifest.sourceMode ?? 'SIMULATION';
  const rules = round?.manifest.rules ?? game.rules;
  const isTrafficPulse = game.gameId === 'traffic-pulse';
  return (
    <div className="prose" data-testid="rules">
      <p>
        <strong>{t(gameBlurbKey(game.gameId))}</strong>
      </p>
      {isTrafficPulse ? (
        <>
          <p>{t('rules.what')}</p>
          <p>{t('rules.classes')}</p>
        </>
      ) : (
        <p lang="en">{game.rulesText}</p>
      )}
      <p>{t('rules.window')}</p>
      {round?.manifest.thresholds && <p>{t('rules.bands', { low: round.manifest.thresholds.low, high: round.manifest.thresholds.high })}</p>}
      {round?.manifest.bands && <p>{t('rules.bandsCamera', { n: round.manifest.bands.windows, median: round.manifest.bands.median })}</p>}
      {round && (
        <table className="rules-table">
          <tbody>
            {round.manifest.odds.map((o) => (
              <tr key={o.selection}>
                <th scope="row">{selectionLabel(t, o.selection)}</th>
                <td>{conditionText(t, rules, o.selection)}</td>
                <td className="tabular">{fmtOdds(o.odds, intl)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p>{t('rules.payout')}</p>
      <p>{t('rules.review')}</p>
      {t(`game.limit.${game.gameId}` as MessageKey) !== `game.limit.${game.gameId}` && <p className="note">{t(`game.limit.${game.gameId}` as MessageKey)}</p>}
      <p>{t('rules.mode', { mode: t(`mode.${mode}` as MessageKey), hint: mode === 'SIMULATION' ? t('mode.SIMULATION.hint') : '' })}</p>
      {!realMoney && <p className="note">{t('rules.demo')}</p>}
      {round && <p className="note mono">{t('rules.game', { version: round.manifest.rulesVersion })}</p>}
    </div>
  );
}
